import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
  Flex,
  HStack,
  FormLabel,
  Input,
  FormControl,
  Button,
  Textarea,
  RadioGroup,
  Radio,
  Stack,
  Checkbox,
  Box,
  Select,
  Spinner,
  useRadioGroup,
} from "@chakra-ui/react";
import { FaStar, FaRegStar } from "react-icons/fa";
import { MdSwapHoriz } from "react-icons/md";
import { Icon, FormHelperText } from "@chakra-ui/react";
import { ToastContainer, toast } from "react-toastify";
import FadeIn from "react-fade-in/lib/FadeIn";
import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import {
  getSurveyQuestions,
  handleSurveySubmit,
  callSurveyAPI,
  checkRegisteredMember,
  pollTransactionByRequestId,
} from "../../utils/api";
import { handleInputSurvey, NOT_REGISTERED_MESSAGE } from "../../utils/functions";
import AttendanceTemplate from "./AttendanceTemplate";
import DynamicSelectInput from "./DynamicSelect";
import {
  getTemplateActionWord,
  isRegistrationSurveyName,
} from "../../utils/templateWords";
import OptionsWithCheckboxes from "./OptionsWithCheckboxes";
import BusinessItemsView from "./BusinessItemsView";
import { RadioCard } from "./RadioOption";
import { getVisibleQuestions, getValidationErrors } from "../../utils/surveyRules";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
  control: {
    padding: 30,
    borderRadius: 0,
  },
});

export const checkboxTheme = defineMultiStyleConfig({ baseStyle });

const SurveyDrawer = React.memo(
  ({
    placement = "bottom",
    onClose,
    isCentered,
    subActive,
    payLink,
    data,
    colorMain,
    number,
    phoneLength,
    name,
    setName,
    disabled,
    trigger,
    setPhoneLength,
    setNumber,
    survey,
    contactId,
    registeredOnly,
    isRegisteredMember,
    amount,
    setAmount,
    handlePaymentSurvey,
    triggerSurvey,
    setTriggerSurvey,
    setRequestId,
    reqSurveyId,
    setSelection,
    selectedOption,
    urlOption,
    defaultOptions,
    paymentData,
  }) => {
    const [isChecked, setIsChecked] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState({});
    const [touched, setTouched] = useState({});
    const [clicked, setClicked] = useState(false);
    const [apiResponse, setApiResponse] = useState(null);
    const [isPresetAmount, setIsPresetAmount] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    // M-Pesa survey payments: null | "processing" | "paid" | "failed" | "timeout"
    const [paymentState, setPaymentState] = useState(null);
    const [currencyMode, setCurrencyMode] = useState("BASE");
    const [payType, setPayType] = useState('mpesa'); // 'mpesa' or 'card'
    const [isExplicitCardQuestion, setIsExplicitCardQuestion] = useState(false);
    const [isExplicitMpesaQuestion, setIsExplicitMpesaQuestion] = useState(false);
    let phoneButtonConfig = null;
    const phoneButtonLabelRaw = data?.data?.saledata?.sale_settings?.phone_button_label;
    if (phoneButtonLabelRaw) {
      try {
        phoneButtonConfig = JSON.parse(phoneButtonLabelRaw);
      } catch (e) {
        phoneButtonConfig = null;
      }
    }

    const multicurrencySetting = data?.data?.saledata?.sale_settings?.multicurrency;
    const [baseCurrency, targetCurrency, conversionRate] = multicurrencySetting
      ? multicurrencySetting.split("#")
      : [null, null, null];

    // Payment Options State
    const [selection, setSelectionState] = useState("");
    const [selectionDetails, setSelectionDetails] = useState([]);
    const [urlOptions, setUrlOptions] = useState([]);
    const [totalSplitAmountB, setTotalSplitAmountB] = useState(0);
    const [isSelectButtonDisabled, setIsSelectButtonDisabled] = useState(false);
    const [isCheckedAanyChecked, setAnyChecked] = useState(false);

    // Handle setSelection prop vs state
    const updateSelection = (val) => {
      setSelectionState(val);
      if (setSelection) setSelection(val);
    };

    // Parsing Pay Details Targets
    useEffect(() => {
      const targetsJson = data?.data?.saledata?.sale_settings?.pay_details_targets;
      if (targetsJson) {
        try {
          const processedJson = targetsJson.includes("'") ? targetsJson.replace(/'/g, '"') : targetsJson;
          const parsed = JSON.parse(processedJson);

          const isInternal = parsed?.isInternalTargets === true;
          const rawTargets = parsed?.targets || [];
          // Map to compatible format for DynamicSelectInput and OptionsWithCheckboxes
          // They expect { value: "Name", target: "Amount" }
          const formattedOptions = rawTargets
            .filter(t => (t.name || t.value)?.trim())
            .map(t => ({
              ...t,
              value: t.name || t.value,
              target: isInternal ? 0 : (t.amount || t.target)
            }));
          setUrlOptions(formattedOptions);
        } catch (error) {
          console.error("Error parsing pay details targets:", error);
          setUrlOptions([]);
        }
      }
    }, [data]);

    // Update Amount based on Selection Logic
    useEffect(() => {
      const detailTo = data?.data?.saledata?.sale_settings?.pay_detail_type;

      if (["select", "dropdown", "multiple_choice", "tiles", "linear_scale", "rating"].includes(detailTo) && selection) {
        const selectedTarget = urlOptions.find(t => t.value === String(selection).split("#")[0]);
        if (selectedTarget && selectedTarget.target > 0) {
          setAmount(parseInt(selectedTarget.target));
        } else if (selectedTarget) {
          setAmount("");
        }
      }
    }, [selection, urlOptions, data, setAmount]);

    let group_id = data?.data?.saledata?.sale_to || "";
    // useEffect(() => {
    //   if (group_id) {
    //     getSurveyQuestions({
    //       group_id,
    //       setSurveyQuestions: setQuestions,
    //     });
    //   }
    // }, [group_id]);

    // useEffect(() => {
    //   if (reqSurveyId) {
    //     callSurveyAPI({
    //       id: reqSurveyId,
    //       setSurveyQuestions: setQuestions });
    //   }
    // }, [reqSurveyId]);
    useEffect(() => {
      if (reqSurveyId) {
        setAmount("");
        setSelectionState("");
        if (setSelection) setSelection("");
        setIsPresetAmount(false);
        setAnswers({});
        setTouched({});
        setIsSubmitted(false);
        setPaymentState(null);
        setPayType("mpesa");
        setIsExplicitCardQuestion(false);
        setIsExplicitMpesaQuestion(false);
        setIsDefaultOverride(false);
        setSelectionDetails([]);
        setTotalSplitAmountB(0);
        setAnyChecked(false);
        setIsChecked(false);
        setApiResponse(null);
        setClicked(false);
        setTriggerSurvey(false);
        const fetchSurvey = async () => {
          const result = await callSurveyAPI(reqSurveyId);
          if (result.success) {
            const res = result.data;
            setQuestions(res);

            const paymentQ = res?.data?.survey_questions?.find((q) =>
              isPaymentQuestion(q)
            );

            if (paymentQ) {
              const parsed = parsePaymentQuestion(paymentQ);
              if (parsed.isPayment) {
                setAmount(parsed.amount);
                parsed?.amount && setIsPresetAmount(true);
                if (parsed.selection) {
                  setSelectionState(parsed.selection);
                  if (setSelection) setSelection(parsed.selection);
                }
                if (parsed.type) {
                  setPayType(parsed.type);
                }
                setIsExplicitCardQuestion(!!parsed.explicitCard);
                setIsExplicitMpesaQuestion(!!parsed.explicitMpesa);
                if (parsed.isDefaultOverride) {
                  setIsDefaultOverride(parsed.isDefaultOverride);
                }
              }
            }
          }
        };
        fetchSurvey();
      }
    }, [reqSurveyId, setAmount, setSelection]);

    // Handle answer change for different question types
    const handleAnswerChange = (questionIndex, answer) => {
      setAnswers((prevAnswers) => {
        if (prevAnswers[questionIndex] === answer) {
          return prevAnswers; // No state update needed
        }
        return {
          ...prevAnswers,
          [questionIndex]: answer,
        };
      });
    };

    // Handle checkbox change
    const handleCheckboxChange = (questionId, option) => {
      setAnswers((prevAnswers) => {
        const currentAnswers = prevAnswers[questionId] || [];
        if (currentAnswers.includes(option)) {
          // Uncheck the checkbox (remove option)
          return {
            ...prevAnswers,
            [questionId]: currentAnswers.filter((item) => item !== option),
          };
        } else {
          // Check the checkbox (add option)
          return {
            ...prevAnswers,
            [questionId]: [...currentAnswers, option],
          };
        }
      });
    };

    let contact_exists = contactId?.length > 0 ? true : false;

    // Handle form submission
    const handleSubmit = async () => {
      // Validate required questions
      const missingRequired = visibleQuestions?.find(q => {
        const isRequired = q.question_required !== false; // Default to true
        if (isPaymentQuestion(q)) return false; // Handled separately
        const answer = answers[q.question_index];
        const hasAnswer = Array.isArray(answer) ? answer.length > 0 : !!answer;
        return isRequired && !hasAnswer;
      });

      if (missingRequired) {
        toast.error(`Please answer the required question: "${missingRequired.question}"`);
        return;
      }

      const firstInvalidIndex = Object.keys(validationErrors)[0];
      if (firstInvalidIndex !== undefined) {
        toast.error(validationErrors[firstInvalidIndex]);
        return;
      }

      let res = null;
      setTriggerSurvey(true);
      setRequestId("");

      // ... existing payment logic ...
      if (hasPaymentQuestion) {
        // console.log(requestId);

        try {
          const finalAmount = currencyMode === "TARGET" && conversionRate
            ? Math.round(amount / parseFloat(conversionRate))
            : amount;

          res = await handlePaymentSurvey(finalAmount, payType, selection, selectionDetails);

          if (!res) {
            toast.error("Payment trigger failed. Please try again.");
            setTriggerSurvey(false);
            return;
          }

          if (payType === 'card' && res?.status === 'POPUP') {
            // Popup initiated in parent component
            const response_data = Object.keys(submitAnswers).map((questionIndex) => ({
              question_index: questionIndex,
              response: Array.isArray(submitAnswers[questionIndex])
                ? submitAnswers[questionIndex].join(", ")
                : String(submitAnswers[questionIndex]),
            }));

            const paymentQuestion = questions?.data?.survey_questions?.find(
              (q) => isPaymentQuestion(q)
            );

            if (paymentQuestion) {
              response_data.push({
                question_index: String(paymentQuestion.question_index),
                response: res?.request_id || "Initiated Card Payment",
              });
            }

            await handleSurveySubmit({
              group_id,
              survey_id: questions?.data?.id,
              contact_exists,
              contact_id: contact_exists ? contactId : data?.data?.saledata?.org_id,
              contact_name: `${name}, ${number}`,
              response_data,
            });

            onClose(); // Close the survey modal
            return;
          }

          if (payType === 'card' && typeof res === 'object' && res?.authorization_url) {
            // Redirect to card payment page
            // First submit the survey response silently if needed, or just redirect
            // Assuming we need to save the response first:
            const response_data = Object.keys(submitAnswers).map((questionIndex) => ({
              question_index: questionIndex,
              response: Array.isArray(submitAnswers[questionIndex])
                ? submitAnswers[questionIndex].join(", ")
                : String(submitAnswers[questionIndex]),
            }));

            const paymentQuestion = questions?.data?.survey_questions?.find(
              (q) => isPaymentQuestion(q)
            );

            if (paymentQuestion) {
              response_data.push({
                question_index: String(paymentQuestion.question_index),
                response: res?.request_id || "Initiated Card Payment", // Or use res (link) but usually status. kept simple.
              });
            }

            await handleSurveySubmit({
              group_id,
              survey_id: questions?.data?.id,
              contact_exists,
              contact_id: contact_exists ? contactId : data?.data?.saledata?.org_id,
              contact_name: `${name}, ${number}`,
              response_data,
            });

            window.location.href = res.authorization_url;
            return; // Stop execution here, don't show success modal
          }

        } catch (error) {
          console.error("Payment failed. Please try again.");
          setTriggerSurvey(false); // Valid catch block needs reset
          return;
        }
      }

      const response_data = Object.keys(submitAnswers).map((questionIndex) => ({
        question_index: questionIndex,
        response: Array.isArray(submitAnswers[questionIndex])
          ? submitAnswers[questionIndex].join(", ") // Join multiple checkbox answers into a single string
          : String(submitAnswers[questionIndex]), // Ensure string for numbers (ratings) or other types
      }));

      if (hasPaymentQuestion && res) { // Logic for M-Pesa or non-redirect flows
        const paymentQuestion = questions?.data?.survey_questions?.find(
          (q) => isPaymentQuestion(q)
        );

        const paymentIndex = paymentQuestion?.question_index;

        if (paymentIndex) {
          response_data.push({
            question_index: String(paymentIndex),
            response: String(res),
          });
        }
      }

      const result = await handleSurveySubmit({
        group_id,
        survey_id: questions?.data?.id,
        contact_exists,
        contact_id: contact_exists ? contactId : data?.data?.saledata?.org_id,
        contact_name: `${name}, ${number}`,
        response_data,
      });

      if (result.success) {
        setIsSubmitted(true);
        // Wait for the M-Pesa result using the request id from the trigger
        if (hasPaymentQuestion && payType === "mpesa" && typeof res === "string" && res) {
          setPaymentState("processing");
          const outcome = await pollTransactionByRequestId(res, amount);
          setPaymentState(outcome.status);
        }
      } else {
        toast.warning(result.message || "an error occurred! please retry");
        setTriggerSurvey(false);
      }
    };

    const capitalizeFirstLetter = (str) => {
      return str.replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const isPaymentQuestion = (question) => {
      // New explicit type
      if (question.question_type === 'payment') return true;
      // Backward compatibility: text type (or undefined) starting with "payment"
      const lowerQ = question.question.toLowerCase();
      return lowerQ.startsWith("payment") && (!question.question_type || question.question_type === 'text');
    };

    // Check if any question is related to payment
    const filteredQuestions = questions?.data?.survey_questions?.filter(
      (question) => !isPaymentQuestion(question)
    );

    // Conditional questions: only the ones whose showIf rules pass are shown,
    // required and submitted. Questions without rules are always visible.
    const visibleQuestions = getVisibleQuestions(filteredQuestions, answers);
    const validationErrors = getValidationErrors(visibleQuestions, answers);
    const submitAnswers = {};
    visibleQuestions.forEach((q) => {
      if (answers[q.question_index] !== undefined) {
        submitAnswers[q.question_index] = answers[q.question_index];
      }
    });

    const hasPaymentQuestion = questions?.data?.survey_questions?.some(
      (question) => isPaymentQuestion(question)
    );
    // console.log(hasPaymentQuestion,  amount)

    const cardPayment = paymentData?.find(
      (payment) => payment?.link_type === "CARD"
    );
    const showPaymentMethodToggle =
      hasPaymentQuestion &&
      !!cardPayment &&
      !isExplicitCardQuestion &&
      !isExplicitMpesaQuestion;

    const paymentMethodOptions = ["mpesa", "card"];
    const {
      getRootProps: getPaymentGroupRootProps,
      getRadioProps: getPaymentRadioProps,
    } = useRadioGroup({
      name: "surveyPaymentType",
      value: payType,
    });
    const paymentGroupProps = getPaymentGroupRootProps();

    const [isDefaultOverride, setIsDefaultOverride] = useState(false);

    const saleSettings0 = data?.data?.saledata?.sale_settings;
    const templateType = saleSettings0?.template_type || "default";
    // Welfare and chama templates don't offer the anonymous option
    const hideAnonymousOption = ["welfare", "chamas"].includes(templateType);

    // Registration forms (name contains "register"/"registration")
    const activeSurveyName =
      data?.data?.all_surveys?.find((s) => s.id === reqSurveyId)?.survey_name ||
      questions?.data?.survey_name ||
      "";
    const isRegistrationSurvey = isRegistrationSurveyName(activeSurveyName);

    const idtagRequired =
      saleSettings0?.idtag_required && !isRegistrationSurvey;
    const idtagLabel = data?.data?.saledata?.sale_settings?.idtag_label || "ID Tag";
    const nameParts = (name || "").split("#");
    const baseName = nameParts.length > 1 ? nameParts.slice(0, -1).join("#").trim() : (nameParts[0] || "");
    const idTag = nameParts.length > 1 ? nameParts[nameParts.length - 1].trim() : "";

    // Registration forms: warn when the phone/email already belongs to a contact
    const [existingRegistration, setExistingRegistration] = useState(null);
    const saleTo = data?.data?.saledata?.sale_to;
    useEffect(() => {
      const value = (number || "").trim();
      const isPhoneLike = /^\d+$/.test(value);
      const isReady = isPhoneLike
        ? value.length === phoneLength
        : value.length >= 4;

      setExistingRegistration(null);
      if (!isRegistrationSurvey || !saleTo || !isReady) return;

      let cancelled = false;
      const handle = setTimeout(
        async () => {
          const result = await checkRegisteredMember(saleTo, value);
          if (!cancelled && result.found) {
            setExistingRegistration({ name: result.name });
          }
        },
        isPhoneLike ? 0 : 600
      );
      return () => {
        cancelled = true;
        clearTimeout(handle);
      };
    }, [number, phoneLength, isRegistrationSurvey, saleTo]);

    const parsePaymentQuestion = (question) => {
      if (!isPaymentQuestion(question)) {
        return { isPayment: false };
      }

      const source =
        (question.question && question.question.toLowerCase().startsWith('payment') && question.question.includes("#"))
          ? question.question
          : (question.question_options || "");

      const parts = source.split("#");


      if (parts.length <= 1) { // Changed to <= 1 to handle empty split or no match cleanly
        // "payment" or empty
        return {
          isPayment: true,
          selection: "",
          amount: "",
          isDefaultOverride: false,
          explicitCard: false,
          explicitMpesa: false
        };
      }

      if (parts.length >= 2) {
        // Check parts[0] for type
        const typePart = parts[0].toLowerCase(); // e.g., "payment-card", "payment-mpesa" or "payment"
        const type = typePart.includes('card') ? 'card' : 'mpesa';

        const value = parts[1];
        let selection = "";
        let amountVal = "";

        if (!isNaN(value)) {
          amountVal = parseInt(value, 10);
        } else {
          selection = value;
        }

        let isDefault = false;

        if (parts.length >= 3) {
          amountVal = parseInt(parts[2], 10) || "";
        }

        if (parts.length >= 4) {
          if (parts[3] === "Default") {
            isDefault = true;
          }
        }

        return {
          isPayment: true,
          selection,
          amount: amountVal,
          type,
          isDefaultOverride: isDefault,
          explicitCard: typePart.includes('card'),
          explicitMpesa: typePart.includes('mpesa')
        };
      }

      return { isPayment: false };
    };




    // Subcategories: selection is stored as "category" or "category#subcategory"
    const selectedCategory = selection ? String(selection).split("#")[0] : "";
    const selectedSubCategory = selection
      ? String(selection).split("#").slice(1).join("#")
      : "";
    const subCategoryOptions = (
      urlOptions.find((t) => t.value === selectedCategory)?.subCategories || ""
    )
      .split(",")
      .map((sub) => sub.trim())
      .filter(Boolean)
      .map((sub) => ({ value: sub }));
    const needsSubCategory =
      subCategoryOptions.length > 0 && !selectedSubCategory;
    const surveyActionWord = getTemplateActionWord(
      data?.data?.saledata?.sale_settings?.template_type || "default"
    );

    return (
      questions &&
      questions?.data?.survey_questions && (
        <Modal
          isOpen={survey}
          onClose={onClose}
          isCentered={true}
          closeOnOverlayClick={trigger ? false : true}
          size="md"
        >
          <ToastContainer />
          <ModalOverlay />
          {payLink === undefined || !subActive ? (
            <ModalContent mb="300">
              <ModalCloseButton />
              <ModalBody p={6} fontSize="xl">
                <Text>
                  Unfortunately, this service is temporarily unavailable as the
                  organizer's plan needs to be renewed. Please check back later
                  or contact the organizer for further assistance. We sincerely
                  apologize for the inconvenience.
                </Text>
              </ModalBody>
            </ModalContent>
          ) : (
            <>
              <ModalOverlay />
              <ModalContent borderTopRadius="2xl" fontFamily="'Poppins', sans-serif">
                <ModalCloseButton />
                <ModalHeader
                  mt={4}
                  textAlign="center"
                  mb={2}
                  color={colorMain}
                  fontSize="lg"
                  fontWeight="bold"
                >
                  {isSubmitted
                    ? paymentState === "processing"
                      ? "Processing payment..."
                      : paymentState === "paid"
                        ? "Payment complete!"
                        : paymentState === "failed"
                          ? "Payment not completed"
                          : "Success!"
                    : "Please answer the questions below"}
                </ModalHeader>
                <ModalBody py={4} color={colorMain}>
                  {isSubmitted ? (
                    <FadeIn>
                      <Flex
                        flexDir="column"
                        alignItems="center"
                        justifyContent="center"
                        textAlign="center"
                        h="100%"
                        py={10}
                      >
                        {paymentState === "processing" ? (
                          <>
                            <Spinner size="xl" color={colorMain} thickness="4px" mb={6} />
                            <Text fontSize="lg" fontWeight="medium" mb={2}>
                              Processing your payment
                            </Text>
                            <Text fontSize="md" color="gray.600" mb={4}>
                              Check your phone and enter your M-Pesa PIN. Please keep this window open.
                            </Text>
                          </>
                        ) : (
                          <>
                            <Box
                              boxSize="60px"
                              borderRadius="full"
                              bg={paymentState === "failed" ? "red.100" : "green.100"}
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              mb={6}
                            >
                              <Box
                                as="span"
                                color={paymentState === "failed" ? "red.500" : "green.500"}
                                fontSize="3xl"
                                fontWeight="bold"
                              >
                                {paymentState === "failed" ? "✕" : "✓"}
                              </Box>
                            </Box>
                            <Text fontSize="lg" fontWeight="medium" mb={4}>
                              {paymentState === "paid"
                                ? `Payment complete. ${questions?.data?.survey_on_submit_message || "Thank you for your submission!"}`
                                : paymentState === "failed"
                                  ? "Your response was saved, but the payment was not completed."
                                  : paymentState === "timeout"
                                    ? "Your response was saved. We could not confirm the payment yet - if you paid, it will reflect shortly."
                                    : questions?.data?.survey_on_submit_message || "Thank you for your submission!"}
                            </Text>
                          </>
                        )}
                        <Button
                          onClick={() => window.location.reload()}
                          colorScheme="teal"
                          borderRadius="full"
                          px={8}
                          mt={4}
                        >
                          Close
                        </Button>
                      </Flex>
                    </FadeIn>
                  ) : questions?.data?.survey_template === "attendance" ? (
                    <AttendanceTemplate
                      questions={questions}
                      answers={answers}
                      handleAnswerChange={handleAnswerChange}
                      setTriggerSurvey={setTriggerSurvey}
                      setName={setName}
                      setNumber={setNumber}
                    />
                  ) : (
                    <FadeIn>
                      {questions?.data?.survey_description && (
                        <Box mb={6} bg="blue.50" p={4} borderRadius="md">
                          <Text fontSize="lg" color="gray.700">
                            {questions.data.survey_description}
                          </Text>
                        </Box>
                      )}
                      <Flex
                        w="100%"
                        alignItems="center"
                        justifyContent="space-between"
                        flexDir="column"
                      >
                        <FormControl isRequired mt={2} mb={6}>
                          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
                            {payType === 'card'
                              ? phoneButtonConfig?.cardPrompt || (!phoneButtonConfig && phoneButtonLabelRaw) || "Phone number"
                              : phoneButtonConfig?.mpesaPrompt || "Phone number"}
                          </FormLabel>
                          <Input
                            size="lg"
                            fontSize="xl"
                            type="text"
                            placeholder={!number ? "Enter required text here" : ""}
                            value={number}
                            onChange={(e) =>
                              handleInputSurvey(e, setPhoneLength, setNumber)
                            }
                            borderRadius="md"
                          />
                          {registeredOnly &&
                            number?.length === phoneLength &&
                            !disabled &&
                            !isRegisteredMember && (
                              <FormHelperText
                                textAlign="center"
                                color="red.500"
                                fontSize="sm"
                              >
                                {NOT_REGISTERED_MESSAGE}
                              </FormHelperText>
                            )}
                          {existingRegistration && (
                            <Box
                              mt={3}
                              p={3}
                              borderRadius="md"
                              bg="orange.50"
                              borderLeft="4px solid"
                              borderColor="orange.400"
                            >
                              <Text fontSize="sm" color="orange.800">
                                {existingRegistration.name
                                  ? `You are already registered as '${existingRegistration.name}', do you want to continue?`
                                  : "You are already registered, do you want to continue?"}
                              </Text>
                            </Box>
                          )}
                        </FormControl>
                      </Flex>

                      {number?.length === phoneLength && (
                        <FadeIn>
                          <FormControl mb={6}>
                            <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
                              {data?.data.saledata?.sale_settings?.name_label ||
                                "Name"}
                            </FormLabel>
                            <Input
                              size="lg"
                              fontSize="xl"
                              type="text"
                              placeholder={!baseName ? "Enter details here" : ""}
                              value={isChecked ? "Anonymous" : baseName}
                              onChange={(e) => setName(idTag ? `${e.target.value}#${idTag}` : e.target.value)}
                              isDisabled={disabled}
                              borderRadius="md"
                            />
                          </FormControl>
                          {idtagRequired && (
                            <FormControl mb={6}>
                              <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
                                {idtagLabel}
                              </FormLabel>
                              <Input
                                size="lg"
                                fontSize="xl"
                                type="text"
                                placeholder={`Enter ${idtagLabel} here`}
                                value={isChecked ? "" : idTag}
                                onChange={(e) => setName(e.target.value ? `${baseName}#${e.target.value}` : baseName)}
                                isDisabled={disabled}
                                borderRadius="md"
                              />
                            </FormControl>
                          )}
                          {!hideAnonymousOption && (
                          <Checkbox
                            mt={2}
                            mb={6}
                            size="md"
                            colorScheme="teal"
                            isChecked={isChecked}
                            onChange={() => setIsChecked(!isChecked)}
                          >
                            Fill anonymously
                          </Checkbox>
                          )}
                        </FadeIn>
                      )}

                      {visibleQuestions?.map((question) => (
                        <Box
                          key={question.question_index}
                          onBlur={() =>
                            setTouched((prev) => ({ ...prev, [question.question_index]: true }))
                          }
                        >
                          <SurveyQuestion
                            question={question}
                            handleAnswerChange={handleAnswerChange}
                            handleCheckboxChange={handleCheckboxChange}
                            answers={answers}
                            capitalizeFirstLetter={capitalizeFirstLetter}
                          />
                          {touched[question.question_index] &&
                            validationErrors[question.question_index] && (
                              <Text mt={-4} mb={6} fontSize="sm" color="red.500">
                                {validationErrors[question.question_index]}
                              </Text>
                            )}
                        </Box>
                      ))}

                      {showPaymentMethodToggle && (
                        <Box mt={6} mb={2}>
                          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600" mb={2}>
                            Choose payment method
                          </FormLabel>
                          <HStack
                            {...paymentGroupProps}
                            outline=".0082rem solid #bbbbbb"
                            shadow="base"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            w="100%"
                            height="36px"
                            borderRadius="md"
                            px={0}
                            position="relative"
                          >
                            {paymentMethodOptions.map((value) => {
                              const radio = getPaymentRadioProps({ value });
                              return (
                                <RadioCard
                                  isDisabled={trigger}
                                  key={value}
                                  {...radio}
                                  onChange={() => setPayType(value)}
                                >
                                  {value === "mpesa" ? "MPESA" : "CARD"}
                                </RadioCard>
                              );
                            })}
                          </HStack>
                        </Box>
                      )}

                      {/* Render the Amount Input Separately */}
                      {hasPaymentQuestion &&
                        (!isPresetAmount ||
                          ["select", "dropdown", "multiple_choice", "tiles", "linear_scale", "rating", "options", "checkboxes"].includes(data?.data?.saledata?.sale_settings?.pay_detail_type)) && (
                          <Box mt={6} mb={6}>
                            <FadeIn>
                              {/* Currency Header / Toggle */}
                              <Flex
                                alignItems="baseline"
                                mb={2}
                                justifyContent="space-between"
                              >
                                <FormLabel fontSize="lg" fontWeight="medium" color="gray.600" mb={0}>
                                  {questions?.data?.survey_questions?.find(q => isPaymentQuestion(q))?.question || "Enter the amount to pay"}
                                </FormLabel>

                                {baseCurrency && targetCurrency && conversionRate && (
                                  <Button
                                    size="xs"
                                    leftIcon={<Icon as={MdSwapHoriz} />}
                                    onClick={() => setCurrencyMode(prev => prev === "BASE" ? "TARGET" : "BASE")}
                                    variant="ghost"
                                    colorScheme="teal"
                                  >
                                    Swap to {currencyMode === "BASE" ? targetCurrency : baseCurrency}
                                  </Button>
                                )}
                              </Flex>

                              {/* Amount Input Area or Payment Options */}

                              {(() => {
                                const detailTo = data?.data?.saledata?.sale_settings?.pay_detail_type;
                                const saleSettings = data?.data?.saledata?.sale_settings;

                                if (["select", "dropdown", "multiple_choice", "tiles", "linear_scale", "rating"].includes(detailTo) && !isDefaultOverride) {
                                  return (
                                    <Box mb={6}>
                                      <FormLabel fontSize="xl" mt={2} fontWeight="bold">
                                        {saleSettings?.pay_detail_button_name || "Select"}
                                      </FormLabel>
                                      <DynamicSelectInput
                                        mb={4}
                                        options={urlOptions}
                                        condition={selectedOption}
                                        value={selectedCategory}
                                        onChange={(e) => updateSelection(e.target.value)}
                                        required
                                        isDisabled={selectedOption}
                                      />
                                      {subCategoryOptions.length > 0 && (
                                        <>
                                          <FormLabel fontSize="xl" mt={2} fontWeight="bold">
                                            Subcategory
                                          </FormLabel>
                                          <DynamicSelectInput
                                            mb={4}
                                            options={subCategoryOptions}
                                            value={selectedSubCategory}
                                            placeholder="Select a subcategory"
                                            onChange={(e) =>
                                              updateSelection(`${selectedCategory}#${e.target.value}`)
                                            }
                                            isDisabled={selectedOption}
                                          />
                                        </>
                                      )}
                                      {/* Show calculated amount or input for custom amount */}
                                      <Flex alignItems="center" mt={2}>
                                        <Text fontSize="lg" fontWeight="bold" mr={2}>Amount:</Text>
                                        {(() => {
                                          const selectedTarget = urlOptions.find(t => t.value === selectedCategory);
                                          const hasPredefinedTarget = selectedTarget && selectedTarget.target > 0;
                                          if (hasPredefinedTarget) {
                                            return <Text fontSize="lg">{amount > 0 ? Number(amount).toLocaleString() : 0}</Text>;
                                          } else {
                                            return (
                                              <Input
                                                size="xl"
                                                w="150px"
                                                type="number"
                                                min="1"
                                                placeholder="Enter amount"
                                                value={amount}
                                                isReadOnly={selectedOption}
                                                onChange={(e) => {
                                                  const val = e.target.value === "" ? "" : Math.round(e.target.value);
                                                  setAmount(val);
                                                }}
                                              />
                                            );
                                          }
                                        })()}
                                      </Flex>
                                    </Box>
                                  );
                                } else if (["options", "checkboxes"].includes(detailTo) && !isDefaultOverride) {
                                  return (
                                    <Box mb={6}>
                                      <FormLabel fontSize="xl" mt={2} fontWeight="bold">
                                        {saleSettings?.pay_detail_button_name || "Select"}
                                      </FormLabel>
                                      <Text fontSize="lg" color="gray.600" mb={4}>
                                        Select one or multiple items to proceed
                                      </Text>
                                      <BusinessItemsView
                                        urlOptions={urlOptions}
                                        colorMain={colorMain}
                                        setSelectionDetails={setSelectionDetails}
                                        setIsSelectButtonDisabled={setIsSelectButtonDisabled}
                                        setTotalSplitAmountB={setTotalSplitAmountB}
                                        amount={amount}
                                        setAmount={setAmount}
                                        setAnyChecked={setAnyChecked}
                                        currencyText={currencyMode === "BASE" || payType !== 'card' ? (baseCurrency || "KES") : targetCurrency}
                                        urlOption={urlOption}
                                        isDisabled={selectedOption}
                                      />
                                    </Box>
                                  );
                                }

                                // Default fallback to original Amount Input
                                return (
                                  <>
                                  {defaultOptions?.length > 0 && !isPresetAmount && (
                                    <Flex wrap="wrap" gap={2} mb={3}>
                                      {defaultOptions.map((opt) => {
                                        const val = parseInt(opt, 10);
                                        const currency = currencyMode === "BASE" || payType !== "card" ? (baseCurrency || "KES") : targetCurrency;
                                        return (
                                          <Button
                                            key={opt}
                                            size="sm"
                                            variant={Number(amount) === val ? "solid" : "outline"}
                                            colorScheme="teal"
                                            borderRadius="full"
                                            onClick={() => setAmount(val)}
                                          >
                                            {currency} {Number(val).toLocaleString()}
                                          </Button>
                                        );
                                      })}
                                    </Flex>
                                  )}
                                  <Flex
                                    direction="column"
                                    p={4}
                                    borderWidth="1px"
                                    borderRadius="lg"
                                    borderColor="gray.200"
                                    bg="gray.100"
                                    _focusWithin={{ borderColor: "teal.500", boxShadow: "0 0 0 1px teal.500" }}
                                  >
                                    <Flex alignItems="baseline">
                                      <Text fontSize="lg" fontWeight="bold" color="gray.500" mr={2}>
                                        {currencyMode === "BASE" || payType !== 'card' ? (baseCurrency || "KES") : targetCurrency}
                                      </Text>
                                      <Input
                                        size="lg"
                                        fontSize="3xl"
                                        fontWeight="bold"
                                        type="number"
                                        variant="unstyled"
                                        placeholder="0.00"
                                        value={amount}
                                        isReadOnly={selectedOption || isPresetAmount}
                                        onChange={(e) => {
                                          const val = Math.round(e.target.value);
                                          setAmount(val); // Keep as integer
                                        }}
                                        min={1}
                                        // Remove arrows/spinners logic via css usually, typically handled globally or with specific styles
                                        sx={{
                                          "::-webkit-inner-spin-button": { appearance: "none" },
                                          "::-webkit-outer-spin-button": { appearance: "none" },
                                          MozAppearance: "textfield"
                                        }}
                                      />
                                    </Flex>
                                    {/* Conversion Text */}
                                    {baseCurrency && targetCurrency && conversionRate && amount > 0 && (
                                      <Text fontSize="lg" color="gray.600" mt={1} fontWeight="medium">
                                        ≈ {currencyMode === "BASE"
                                          ? Math.round(amount * conversionRate)
                                          : Math.round(amount / conversionRate)} {currencyMode === "BASE" ? targetCurrency : baseCurrency}
                                      </Text>
                                    )}
                                  </Flex>
                                  </>
                                );
                              })()}
                            </FadeIn>
                          </Box>
                        )}
                    </FadeIn>
                  )}
                </ModalBody>

                {!isSubmitted && (
                  <ModalFooter
                    align="center"
                    justify="center"
                    display="flex"
                    flexDir="column"
                    pb={8}
                  >
                    {hasPaymentQuestion &&
                      isPresetAmount &&
                      questions?.data?.survey_questions.some(
                        (question) => answers[question.question_index]
                      ) &&
                      number?.length === phoneLength &&
                      name?.trim() && (
                        <Box
                          p={4}
                          border="1px solid"
                          borderColor="gray.200"
                          borderRadius="xl"
                          display="flex"
                          flexDir="column"
                          alignItems="center"
                          mb={4}
                          bg="gray.50"
                          w="100%"
                        >
                          <Flex alignItems="center" mb={2} width="100%" justifyContent="center">
                            <Box
                              boxSize="16px"
                              borderRadius="full"
                              bg="green.400"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              mr={2}
                            >
                              <Box
                                as="span"
                                color="white"
                                fontSize="xs"
                                fontWeight="bold"
                              >
                                ✓
                              </Box>
                            </Box>
                            <Text
                              color={colorMain}
                              fontSize="lg"
                              fontWeight="bold"
                            >
                              {payType === 'card' ? 'CARD' : 'M-PESA'}
                            </Text>
                          </Flex>

                          <Text fontSize="xs" color="gray.500" textAlign="center">
                            {payType === 'card'
                              ? "You will be redirected to complete your card payment."
                              : "You will receive STK Push on your phone to complete payment."}
                          </Text>
                        </Box>
                      )}
                    <Button
                      onClick={handleSubmit}
                      bgColor={colorMain}
                      isDisabled={
                        (questions?.data?.survey_template !== 'attendance' && (number?.length !== phoneLength || !name.trim())) ||
                        // Check if all required questions are answered
                        visibleQuestions.some(q => {
                          const isRequired = q.question_required !== false;
                          const hasAnswer = answers[q.question_index] &&
                            (Array.isArray(answers[q.question_index]) ? answers[q.question_index].length > 0 : true);
                          return isRequired && !hasAnswer;
                        }) ||
                        Object.keys(validationErrors).length > 0 ||
                        (hasPaymentQuestion && amount < 1) ||
                        (hasPaymentQuestion && needsSubCategory) ||
                        (idtagRequired && !idTag?.trim()) ||
                        (registeredOnly && !isRegisteredMember)
                      }
                      color="white"
                      size="lg"
                      w="100%"
                      borderRadius="full"
                      fontWeight="bold"
                      fontSize="xl"
                      isLoading={triggerSurvey}
                      _hover={{ opacity: 0.9 }}
                    >
                      {triggerSurvey
                        ? "Processing..."
                        : hasPaymentQuestion && amount >= 1
                          ? `${surveyActionWord} ${currencyMode === "BASE" || payType !== 'card' ? (baseCurrency || "KES") : targetCurrency} ${Number(amount).toLocaleString()}`
                          : hasPaymentQuestion
                            ? `${surveyActionWord} and Submit`
                            : "Submit"}
                    </Button>
                  </ModalFooter>
                )}
              </ModalContent>
            </>
          )}
        </Modal >
      )
    );
  }
);

export default SurveyDrawer;

const SurveyQuestion = ({
  question,
  handleAnswerChange,
  handleCheckboxChange,
  answers,
  capitalizeFirstLetter,
}) => {
  const options = question.question_options
    .split(/,\s*/i)
    .map((option) => option.toLowerCase());

  const isBooleanQuestion =
    (options.length === 2 &&
      options.includes("yes") &&
      options.includes("no")) ||
    (options.length === 2 &&
      options.includes("one") &&
      options.includes("two")) ||
    (options.length === 2 &&
      options.includes("true") &&
      options.includes("false")) ||
    (options.length === 3 &&
      options.includes("yes") &&
      options.includes("no") &&
      options.includes("not sure")) ||
    (options.length === 3 &&
      options.includes("true") &&
      options.includes("false") &&
      options.includes("not sure"));

  const isRequired = question.question_required !== false; // Default to true

  switch (question.question_type) {
    case "text":
    case "short_answer":
      return (
        <Box key={question.question_index} mb={6}>
          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
            {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
          </FormLabel>
          <Input
            type="text"
            fontSize="xl"
            placeholder="Your answer"
            value={answers[question.question_index] || ""}
            onChange={(e) =>
              handleAnswerChange(question.question_index, e.target.value)
            }
            borderRadius="md"
          />
        </Box>
      );
    case "paragraph":
      return (
        <Box key={question.question_index} mb={6}>
          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
            {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
          </FormLabel>
          <Textarea
            type="text"
            fontSize="xl"
            placeholder="Your answer"
            value={answers[question.question_index] || ""}
            onChange={(e) =>
              handleAnswerChange(question.question_index, e.target.value)
            }
            borderRadius="md"
          />
        </Box>
      );
    case "rating":
      return (
        <Box key={question.question_index} mb={6}>
          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
            {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
          </FormLabel>
          <Flex gap={2}>
            {[1, 2, 3, 4, 5].map((star) => (
              <Box
                key={star}
                as="button"
                onClick={() => handleAnswerChange(question.question_index, star)}
                _hover={{ transform: "scale(1.1)" }}
                transition="all 0.2s"
              >
                {answers[question.question_index] >= star ? (
                  <FaStar size={24} color="#ECC94B" /> // Yellow-400 equivalent
                ) : (
                  <FaRegStar size={24} color="#CBD5E0" /> // Gray-400 equivalent
                )}
              </Box>
            ))}
          </Flex>
          {answers[question.question_index] && (
            <Text fontSize="xs" color="gray.500" mt={1}>
              {answers[question.question_index]} out of 5
            </Text>
          )}
        </Box>
      );
    case "multiple_choice":
    case "select": // Legacy support
      return (
        <Box key={question.question_index} mb={6}>
          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
            {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
          </FormLabel>
          <RadioGroup
            fontSize="xl"
            value={answers[question.question_index] || ""}
            onChange={(value) =>
              handleAnswerChange(question.question_index, value)
            }
          >
            <Stack direction="column" spacing={3}>
              {options.map((option, idx) => (
                <Radio
                  key={idx}
                  value={option}
                  colorScheme="teal"
                  size="md"
                >
                  <Text fontSize="lg">
                    {capitalizeFirstLetter(option)}
                  </Text>
                </Radio>
              ))}
            </Stack>
          </RadioGroup>
        </Box>
      );
    case "checkboxes":
      return (
        <Box key={question.question_index} mb={6}>
          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
            {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
          </FormLabel>
          <Stack direction="column" spacing={3}>
            {options.map((option, idx) => (
              <Checkbox
                key={idx}
                value={option}
                colorScheme="teal"
                size="xl"
                isChecked={
                  answers[question.question_index]?.includes(option) ||
                  false
                }
                onChange={() =>
                  handleCheckboxChange(question.question_index, option)
                }
              >
                <Text fontSize="lg">{capitalizeFirstLetter(option)}</Text>
              </Checkbox>
            ))}
          </Stack>
        </Box>
      );
    case "dropdown":
      return (
        <Box key={question.question_index} mb={6}>
          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
            {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
          </FormLabel>
          <Select
            placeholder="Select an option"
            value={answers[question.question_index] || ""}
            onChange={(e) => handleAnswerChange(question.question_index, e.target.value)}
          >
            {options.map((option, idx) => (
              <option key={idx} value={option}>
                {capitalizeFirstLetter(option)}
              </option>
            ))}
          </Select>
        </Box>
      );
    case "linear_scale":
      // For linear scale, we'll assume standard 1-5 or 1-10 if not specified, 
      // but here we might just render buttons based on options if provided, 
      // or default to 1-5 if options are empty/weird. 
      // The alpha app sends data like scaleMin/scaleMax. 
      // If the API transforms it to options "1, 2, 3, 4, 5", we use that.
      // If options are empty, we might default to 1-5.
      const scaleOptions = options.length > 0 ? options : ["1", "2", "3", "4", "5"];
      return (
        <Box key={question.question_index} mb={6}>
          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
            {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
          </FormLabel>
          <Flex gap={2} wrap="wrap">
            {scaleOptions.map((opt) => (
              <Button
                key={opt}
                onClick={() => handleAnswerChange(question.question_index, opt)}
                colorScheme={answers[question.question_index] === opt ? "teal" : "gray"}
                variant={answers[question.question_index] === opt ? "solid" : "outline"}
                size="xl"
                width="40px"
                height="40px"
              >
                {opt}
              </Button>
            ))}
          </Flex>
        </Box>
      );
    case "date":
      return (
        <Box key={question.question_index} mb={6}>
          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
            {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
          </FormLabel>
          <Input
            type="date"
            fontSize="xl"
            value={answers[question.question_index] || ""}
            onChange={(e) =>
              handleAnswerChange(question.question_index, e.target.value)
            }
            borderRadius="md"
          />
        </Box>
      );
    case "time":
      return (
        <Box key={question.question_index} mb={6}>
          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
            {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
          </FormLabel>
          <Input
            type="time"
            fontSize="xl"
            value={answers[question.question_index] || ""}
            onChange={(e) =>
              handleAnswerChange(question.question_index, e.target.value)
            }
            borderRadius="md"
          />
        </Box>
      );
    case "consent": {
      // Everything shown comes from the question itself: the statement is
      // question.question and the checkbox label is question_options (optional).
      // Checked -> "Yes", unchecked -> no answer (so Required blocks submit).
      const rawLabel = (question.question_options || "").trim();
      const checkboxLabel = rawLabel && rawLabel.toLowerCase() !== "none" ? rawLabel : "";
      const requiredMark = isRequired && <span style={{ color: "red" }}>*</span>;
      return (
        <Box key={question.question_index} mb={6}>
          {checkboxLabel && (
            <Text fontSize="md" color="gray.600" mb={3} whiteSpace="pre-wrap">
              {question.question} {requiredMark}
            </Text>
          )}
          <Checkbox
            colorScheme="teal"
            size="lg"
            alignItems="flex-start"
            isChecked={answers[question.question_index] === "Yes"}
            onChange={(e) =>
              handleAnswerChange(question.question_index, e.target.checked ? "Yes" : "")
            }
          >
            <Text fontSize="md" color="gray.600" lineHeight="short" whiteSpace="pre-wrap">
              {checkboxLabel || question.question} {!checkboxLabel && requiredMark}
            </Text>
          </Checkbox>
        </Box>
      );
    }
    case "options": // Legacy mixed handling
      if (isBooleanQuestion) {
        return (
          <Box key={question.question_index} mb={6}>
            <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
              {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
            </FormLabel>
            <RadioGroup
              fontSize="xl"
              value={answers[question.question_index] || ""}
              onChange={(value) =>
                handleAnswerChange(question.question_index, value)
              }
            >
              <Stack direction="column" spacing={3}>
                {options.map((option, idx) => (
                  <Radio
                    key={idx}
                    value={option}
                    colorScheme="teal"
                    size="xl"
                  >
                    <Text fontSize="lg">
                      {capitalizeFirstLetter(option)}
                    </Text>
                  </Radio>
                ))}
              </Stack>
            </RadioGroup>
          </Box>
        );
      } else {
        // Fallback or multi-select behavior for 'options' type
        return (
          <Box key={question.question_index} mb={6}>
            <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
              {question.question} {isRequired && <span style={{ color: "red" }}>*</span>}
            </FormLabel>
            <RadioGroup
              fontSize="xl"
              value={answers[question.question_index] || ""}
              onChange={(value) =>
                handleAnswerChange(question.question_index, value)
              }
            >
              <Stack direction="column" spacing={3}>
                {options.map((option, idx) => (
                  <Radio
                    key={idx}
                    value={option}
                    colorScheme="teal"
                    size="xl"
                  >
                    <Text fontSize="lg">
                      {capitalizeFirstLetter(option)}
                    </Text>
                  </Radio>
                ))}
              </Stack>
            </RadioGroup>
          </Box>
        );
      }
    default:
      return null;
  }
};
